import { Box } from '@mui/material'
import React from 'react'

const BoxContainer = ({maxHeight,children,minHeight}) => {
  return (
    <Box
        sx={{
            maxHeight: {maxHeight},
            minHeight: {minHeight},
            overflowY: 'auto',
            "&::-webkit-scrollbar": {
                height: '4px',
                width: '4px',
                background: 'gray',
            },
            "&::-webkit-scrollbar-track": {
                background: '#f1f1f1'
            },
            "&::-webkit-scrollbar-thumb": {
                background: '#888',
                borderRadius: '8px'
            },
            "&::-webkit-scrollbar-thumb:hover": {
                background: 'rgb(30,60,114)'
            },
            "&::-webkit-scrollbar-thumb:horizontal": {
                borderRadius: '10px'
            }
        }}
    > 
    {children}
    </Box>
  )
}

export default BoxContainer